import { Component, Input } from '@angular/core';
import { HvtSection6ContactDto } from '../../../models/notices/ojeu.notice.models';

@Component({
    selector: 'hvt-s6-contact',
    template: require('./hvt.section.6.contact.component.html')
})
export class HvtSection6ContactComponent {
    @Input() contact: HvtSection6ContactDto;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/notices/ojeu/hvt.section.6.contact.component.ts